import React from "react";
import withLocalization from "../../../hoc/with-localization";
const PrmTableExamNo = props => {
    const { exam, loc } = props;
    return (
        <table className="prm-table prm-table-exam-no">
            <tbody>
                <tr>
                    <td className="prm-title prm-title-invert">{loc("report.exam.exam_no")}</td>
                    <td className="prm-data prm-data-invert">{exam}</td>
                </tr>
            </tbody>
        </table>
    );
};

export default withLocalization(PrmTableExamNo);
